import { render, staticRenderFns } from "./TextResourceForm.vue?vue&type=template&id=234cf7ee&"
import script from "./TextResourceForm.vue?vue&type=script&lang=ts&"
export * from "./TextResourceForm.vue?vue&type=script&lang=ts&"
import style0 from "./TextResourceForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports